/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Embed_Captions_Upload_Failed_StatusInputs */



/**
* | output |
* | --- |
* | "Upload Failed: {error}" |
*
* @param {Embed_Captions_Upload_Failed_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_upload_failed_status = /** @type {((inputs: Embed_Captions_Upload_Failed_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Upload_Failed_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Televersement echoue : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Upload fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Caricamento non riuscito: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Загрузка не удалась: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error de carga: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`上传失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`アップロードに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अपलोड विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha no upload: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Upload Failed: ${i?.error}`)
});